import React from 'react';
import {
  formatAttentionLabel,
  formatPortfolioStatus,
  normalizeLifecycleStatus,
  portfolioStatusClass,
} from '../../utils/workSamplesPage';

export default function PortfolioStatusBadges({
  lifecycleStatus,
  storedStatus,
  openFlagCount = 0,
  attentionLabel = null,
  className = '',
}) {
  const lifecycle = normalizeLifecycleStatus(lifecycleStatus || storedStatus);
  const attention =
    attentionLabel || formatAttentionLabel(openFlagCount);

  return (
    <span className={`ws-status-badges ${className}`.trim()}>
      {lifecycle ? (
        <span className={`ws-portfolio-status ${portfolioStatusClass(lifecycle)}`}>
          {formatPortfolioStatus(lifecycle)}
        </span>
      ) : null}
      {attention ? (
        <span className="ws-attention-badge" title={attention}>
          {attention}
        </span>
      ) : null}
    </span>
  );
}
